export default __webpack_public_path__ + "static/media/abmalikimg.4ad452da.png";